import {
  ApiClient,
  Configuration,
  ReportingApi,
  SecurityApi
} from 'bff';
export const initialiseApiClient = (apiConfig: Configuration): ApiClient => ({
  securityApi: new SecurityApi(apiConfig),
  reportingApi: new ReportingApi(apiConfig),
});
